import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdmissionForm from "@/pages/AdmissionForm";
import { LanguageProvider } from "@/lib/i18n";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admission/:token" element={<AdmissionForm />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          className: "rounded-2xl font-body",
        }}
      />
    </div>
  );
}

export default App;
